import {FilterCategoryDefinitionBase} from "./filter-category-definition-base";
import {IGameFilterDefinition} from "../filters-definitions/game-filter-definition.interface";
import {GameThemeFilterDefinition} from "../filters-definitions/theme/game-theme.filter-definition";
import {CategoryDefinitionId} from "./filter-category-definition.interface";
import {Check} from "@sparkware/app-utils";
import {GameThemeId} from "../../game-theme/game-theme-id.enum";

export class GameThemeFiltersCategoryDefinition extends FilterCategoryDefinitionBase {

    get id(): CategoryDefinitionId {
        return 'themes';
    }

    get title(): string {
        return this.services.translation.translate('THEMES');
    }

    get hasItsOwnFiltersOrder(): boolean {
        return !Check.isEmpty(this.services.configuration.data.generalSettings.filters?.advancedFilters?.preferredThemeFilters);
    }

    private _getPreferredThemeFilters(): GameThemeFilterDefinition[] {
        return [
            new GameThemeFilterDefinition("theme_adventure", this.services, this.services.gamesTheme.getGameThemeDefinition(GameThemeId.Adventure)),
            new GameThemeFilterDefinition("theme_ancient-civilization", this.services, this.services.gamesTheme.getGameThemeDefinition(GameThemeId.AncientCivilization)),
            new GameThemeFilterDefinition("theme_wildlife", this.services, this.services.gamesTheme.getGameThemeDefinition(GameThemeId.Wildlife)),
            new GameThemeFilterDefinition("theme_classic_style", this.services, this.services.gamesTheme.getGameThemeDefinition(GameThemeId.ClassicStyle), [GameThemeId.ClassicStyleModernized]),
            new GameThemeFilterDefinition("theme_asian", this.services, this.services.gamesTheme.getGameThemeDefinition(GameThemeId.Asian)),
            new GameThemeFilterDefinition("theme_arabic", this.services, this.services.gamesTheme.getGameThemeDefinition(GameThemeId.Arabic)),
            new GameThemeFilterDefinition("theme_comics_and_cartoons", this.services, this.services.gamesTheme.getGameThemeDefinition(GameThemeId.ComicsAndCartoons)),
            new GameThemeFilterDefinition("theme_diamonds_and_gems", this.services, this.services.gamesTheme.getGameThemeDefinition(GameThemeId.DiamondsAndGems)),
            new GameThemeFilterDefinition("theme_egyptian", this.services, this.services.gamesTheme.getGameThemeDefinition(GameThemeId.Egyptian)),
            new GameThemeFilterDefinition("theme_fantasy_and_folklore", this.services, this.services.gamesTheme.getGameThemeDefinition(GameThemeId.FantasyAndFolklore)),
            new GameThemeFilterDefinition("theme_farm_and_pets", this.services, this.services.gamesTheme.getGameThemeDefinition(GameThemeId.FantasyAndFolklore)),
            new GameThemeFilterDefinition("theme_fish", this.services, this.services.gamesTheme.getGameThemeDefinition(GameThemeId.Fish)),
            new GameThemeFilterDefinition("theme_fruit_and_candy", this.services, this.services.gamesTheme.getGameThemeDefinition(GameThemeId.Fruit)),
            new GameThemeFilterDefinition("theme_greek_mythology", this.services, this.services.gamesTheme.getGameThemeDefinition(GameThemeId.GreekMythology)),
            new GameThemeFilterDefinition("theme_irish", this.services, this.services.gamesTheme.getGameThemeDefinition(GameThemeId.Irish)),
            new GameThemeFilterDefinition("theme_money_and_leisure", this.services, this.services.gamesTheme.getGameThemeDefinition(GameThemeId.MoneyAndLeisure)),
            new GameThemeFilterDefinition("theme_movies_and_music", this.services, this.services.gamesTheme.getGameThemeDefinition(GameThemeId.MoviesAndMusic)),
            new GameThemeFilterDefinition("theme_seasonal", this.services, this.services.gamesTheme.getGameThemeDefinition(GameThemeId.Seasonal)),
            new GameThemeFilterDefinition("theme_space_and_sci-fi", this.services, this.services.gamesTheme.getGameThemeDefinition(GameThemeId.Seasonal)),
        ];
    }


    protected _loadAvailableFilters(): IGameFilterDefinition[] {
        const preferredThemeFilters = this.services.configuration.data.generalSettings.filters?.advancedFilters?.preferredThemeFilters;
        if (Check.isEmpty(preferredThemeFilters)) {
            return this._getPreferredThemeFilters();
        }

        const themesDictionary = this._getPreferredThemeFilters().toDictionary(f => f.id);

        const result: IGameFilterDefinition[] = [];
        for (let filterId of preferredThemeFilters) {
            const filter = themesDictionary[filterId];
            if (filter) {
                result.push(filter);
            } else {
                this.services.logger.error(`There is no filter definition for filter with ID ${filterId}`);
            }
        }

        return result;

    }
}